import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { Integrations } from "@sentry/tracing";
import * as Sentry from "@sentry/react";

Sentry.init({
  dsn: "https://c53e320e32c14ceca92f6c50a8caf6fc@o520888.ingest.sentry.io/5892358",
  integrations: [new Integrations.BrowserTracing()],
  environment: process.env.REACT_APP_ENV,

  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: process.env.REACT_APP_ENV === "stage" ? 1 : 0.5,
});

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
